var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"u-text-center",attrs:{"equalHeight":""}},[_c('i',{class:("fas fa-" + _vm.icon + " fa-5x")}),_c('h5',[_vm._v(_vm._s(_vm.title))]),_c('p',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }